"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowanceValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
exports.allowanceValidationSchema = (0, yup_1.object)().shape({
    address: yup_rules_eth_1.addressValidationSchema,
    amount: yup_rules_eth_1.bigNumberValidationSchema.required("form.validations.valueMissing"),
});
//# sourceMappingURL=validation.js.map